import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, TrendingDown } from "lucide-react";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

export default function StatCard({ 
  title, 
  value, 
  change, 
  changeType = "positive", 
  icon: Icon, 
  iconColor = "bg-blue-500",
  delay = 0 
}) {
  let t = null;
  try {
    const langContext = useLanguage();
    t = langContext?.t;
  } catch (e) {
    // Not wrapped in LanguageProvider
  }
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-slate-500 mb-1">{title}</p>
          <h3 className="text-2xl font-bold text-slate-900">{value}</h3>
          {change && (
            <div className={`flex items-center gap-1 mt-2 text-sm ${
              changeType === "positive" ? "text-emerald-600" : "text-red-500"
            }`}>
              {changeType === "positive" ? (
                <TrendingUp className="h-4 w-4" />
              ) : (
                <TrendingDown className="h-4 w-4" />
              )}
              <span className="font-medium">{change}</span>
              <span className="text-slate-400">{t ? t("vsLastPeriod") : "vs last period"}</span>
            </div>
          )}
        </div>
        <div className={`${iconColor} w-12 h-12 rounded-xl flex items-center justify-center shadow-lg`}>
          <Icon className="h-6 w-6 text-white" />
        </div>
      </div>
    </motion.div>
  );
}